import { apiService, ApiResponse } from './api';

export interface Extra {
  _id: string;
  title: string;
  price: number;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}

class ExtrasService {
  private basePath = '/api/extras';

  async getAllExtras(): Promise<ApiResponse<Extra[]>> {
    return apiService.get<Extra[]>(this.basePath);
  }

  async getExtraById(id: string): Promise<ApiResponse<Extra>> {
    return apiService.get<Extra>(`${this.basePath}/${id}`);
  }

  async createExtra(extraData: Partial<Extra>): Promise<ApiResponse<Extra>> {
    return apiService.post<Extra>(this.basePath, extraData);
  }

  async updateExtra(id: string, extraData: Partial<Extra>): Promise<ApiResponse<Extra>> {
    return apiService.patch<Extra>(`${this.basePath}/${id}`, extraData);
  }

  async deleteExtra(id: string): Promise<ApiResponse<void>> {
    return apiService.delete<void>(`${this.basePath}/${id}`);
  }
}

export const extrasService = new ExtrasService();
